import { CommonModule } from "@angular/common";
import { Component, Optional } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-terms-and-conditions",
  templateUrl: "./terms-and-conditions.component.html",
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, RouterLink]
})
export class TermsAndConditionsComponent {
  readonly isDialogMode: boolean;

  constructor(@Optional() private dialogRef: MatDialogRef<TermsAndConditionsComponent>) {
    this.isDialogMode = Object.keys(dialogRef).length > 0; //check if object is not empty
  }

  /** Links into the app leave the dialog; on the standalone page there is nothing to close. */
  closeDialog(): void {
    if (this.isDialogMode) {
      this.dialogRef.close();
    }
  }
}
